// فهرست مناطق زمانی IANA برای انتخاب (شعبه، تنظیم plt.default_timezone)؛ Asia/Tehran همیشه نخست (ADR-014).
import { DEFAULT_TIME_ZONE } from './jalali';

const FALLBACK = [DEFAULT_TIME_ZONE, 'Asia/Dubai', 'Asia/Kabul', 'Asia/Baghdad', 'Europe/Istanbul', 'UTC'];

/** مناطق زمانی پشتیبانی‌شده مرورگر (Intl.supportedValuesOf) با Asia/Tehran در ابتدا؛ مقدار فعلی همیشه در فهرست است. */
export function supportedTimeZones(current?: string | null): string[] {
  let zones: string[];
  try {
    zones = typeof Intl.supportedValuesOf === 'function' ? Intl.supportedValuesOf('timeZone') : FALLBACK;
  } catch {
    zones = FALLBACK;
  }
  const ordered = [DEFAULT_TIME_ZONE, ...zones.filter((zone) => zone !== DEFAULT_TIME_ZONE)];
  if (current && !ordered.includes(current)) {
    ordered.push(current);
  }
  return ordered;
}
